import * as t from "./types";
import * as actions from "./action";

/* Analysis */
export const getAnalysisAction = (
  payload: t.GetAnalysisRequestType
): t.GetAnalysisActionType => {
  return {
    type: actions.GET_ANALYSIS,
    payload,
  };
};

export const getAnalysesAction = (
  payload: t.GetAnalysesRequestType
): t.GetAnalysesActionType => {
  return {
    type: actions.GET_ANALYSES,
    payload,
  };
};

export const addAnalysisAction = (
  payload: t.CreateAnalysisRequestType
): t.AddAnalysisActionType => {
  return {
    type: actions.ADD_ANALYSIS,
    payload,
  };
};

export const modifyAnalysisAction = (
  payload: t.ModifyAnalysisRequestType
): t.ModifyAnalysisActionType => {
  return {
    type: actions.MODIFY_ANALYSIS,
    payload,
  };
};

export const deleteAnalysisAction = (
  payload: t.DeleteAnalysisRequestType
): t.DeleteAnalysisActionType => {
  return {
    type: actions.DELETE_ANALYSIS,
    payload,
  };
};

export const getAnalysisTeamsAction = (
  payload: t.GetAnalysisTeamsByNameRequestType
): t.GetAnalysisTeamsActionType => {
  return {
    type: actions.GET_ANALYSIS_TEAMS,
    payload,
  };
};

export const addAnalysisTeamAction = (
  payload: t.AddAnalysisTeamRequestType
): t.AddAnalysisTeamActionType => {
  return {
    type: actions.ADD_ANALYSIS_TEAM,
    payload,
  };
};

export const deleteAnalysisTeamAction = (
  payload: t.DeleteAnalysisTeamRequestType
): t.DeleteAnalysisTeamActionType => {
  return {
    type: actions.DELETE_ANALYSIS_TEAM,
    payload,
  };
};
